import { useState, useEffect } from 'react';

import TeamSitesModel from './TeamSitesModel';

export function useTeamSitesByType(props) {
    const { teamId, status, type, enabled = true } = props || {};
    const [sites, setSites] = useState(null);

    const createSite = async (data) => {
        const model = new TeamSitesModel({
            teamId,
        });
        data.type = type || data.type || null;
        return await model.createSite(data);
    };

    const updateSite = async (id, data) => {
        const model = new TeamSitesModel({
            teamId,
        });
        data.type = type || data.type || null;
        return await model.updateSite(id, data);
    };

  const deactivateSite = async (id, updatedByClientId) => {
    const model = new TeamSitesModel({
      teamId,
    });
    return await model.updateSite(id, {
      status: 'deactivated',
      url: null,
      title: null,
      button: null,
      type: type || null,
      ...(updatedByClientId && { updatedByClientId }),
    });
  };

    useEffect(() => {
        if (!enabled) {
            setSites(null);
            return undefined;
        }

        const onUpdate = async (list) => {
            setSites(list);
        };

        const model = new TeamSitesModel({
            teamId,
            status,
            type,
            onUpdate,
        });

        model.start();

        return function cleanup() {
            model.stop();
            setSites(null);
        };
    }, [teamId, status, type, enabled]);

    return [sites, createSite, updateSite, deactivateSite];
}
